import {Component, OnDestroy, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {UserLoginService} from "../../service-auth/user-login.service";
import {CognitoCallback} from "../../service-auth/cognito.service";
import {environment as env} from "../../../environments/environment";

@Component({
    selector: 'app-account',
    templateUrl: './forgotPassword.html',
    styleUrls: ['../component-account.scss']

})
export class ForgotPasswordStep1Component implements CognitoCallback {
    environment = env;
    email: string;
    errorMessage: string;

    constructor(public router: Router,
                public userService: UserLoginService) {
        this.errorMessage = null;
    }

    onNext() {
        this.errorMessage = null;
        this.userService.forgotPassword(this.email, this);
    }

    cognitoCallback(message: string, result: any) {
        if (message == null && result == null) { // error
            this.router.navigate(['/home/forgotPassword', this.email]);
        } else { // success
            this.errorMessage = message;
        }
    }
}


@Component({
    selector: 'app-account',
    templateUrl: './forgotPasswordStep2.html',
    styleUrls: ['../component-account.scss']

})
export class ForgotPassword2Component implements CognitoCallback, OnInit, OnDestroy {

    verificationCode: string;
    email: string;
    password: string;
    errorMessage: string;
    private sub: any;

    constructor(public router: Router, public route: ActivatedRoute,
                public userService: UserLoginService) {
        console.log("email from the url: " + this.email);
    }

    ngOnInit() {
        this.sub = this.route.params.subscribe(params => {
            this.email = params['email'];

        });
        this.errorMessage = null;
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    onNext() {
        this.errorMessage = null;
        this.userService.confirmNewPassword(this.email, this.verificationCode, this.password, this);
    }

    cognitoCallback(message: string) {
        if (message != null) { // error
            this.errorMessage = message;
            console.log("result: " + this.errorMessage);
        } else { // success
            this.router.navigate(['/home/login']);
        }
    }

}
